import React from "react"
import { useTranslation } from 'react-i18next'
import { CSSTransition } from 'react-transition-group'
import { ReactComponent as CameraIcon } from '../../icon/camera.svg'
import { ReactComponent as LibraryIcon } from '../../icon/library.svg'
import { ReactComponent as FlipIcon } from '../../icon/flip-camera.svg'
import { ReactComponent as SwitchDeviceIcon } from '../../icon/mobile.svg'
import SecondaryIconButton from "../buttons/SecondaryIconButton"
import IconButton from "../buttons/IconButton"
import Theme from "../../library/Theme"

interface CameraButtonRowProps {
  show: boolean
  theme: Theme
  canSwitchCamera: boolean
  switchCamera: () => void
  switchDevice: () => void
  startCapture: () => void
  chooseFile: () => void
}

export default function CameraButtonRow({ show, theme, canSwitchCamera, switchCamera, switchDevice, startCapture, chooseFile }: CameraButtonRowProps) {
  const { t } = useTranslation()

  return (
    <CSSTransition in={show} appear timeout={300} classNames="iconAnimate" unmountOnExit>
      <div className="buttonRow">

        <CSSTransition in={canSwitchCamera} appear timeout={300} classNames="iconAnimate" unmountOnExit>
          <SecondaryIconButton id="leftCameraControlButton" theme={theme} text={t("capture.switchCamera")} onPress={switchCamera}>
            <FlipIcon style={theme.svgStyleAlternate} />
          </SecondaryIconButton>
        </CSSTransition>

        <CSSTransition in={!canSwitchCamera} appear timeout={300} classNames="iconAnimate" unmountOnExit>
          <SecondaryIconButton id="leftCameraControlButton" theme={theme} text={t("common.switchDevice")} onPress={switchDevice}>
            <SwitchDeviceIcon style={theme.svgStyleAlternate} />
          </SecondaryIconButton>
        </CSSTransition>

        <IconButton theme={theme} onPress={startCapture}>
          <CameraIcon style={theme.svgStyle} />
        </IconButton>

        <SecondaryIconButton theme={theme} text={t("capture.library")} onPress={chooseFile}>
          <LibraryIcon style={theme.svgStyleAlternate} />
        </SecondaryIconButton>
      </div>
    </CSSTransition>
  )
}
